import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import './assets/Fonts/fonts.css';
import registerServiceWorker from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-dates/initialize';
import ApolloClient from 'apollo-client';
import { ApolloProvider } from 'react-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import * as ReactGA from 'react-ga';

const isProduction = process.env.NODE_ENV === 'production';

let apolloUrl = 'http://localhost:4000';

if (isProduction) {
  apolloUrl = 'https://api.storewithpenn.com';
}

const link = createUploadLink({ uri: apolloUrl });

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById('root') as HTMLElement,
);
registerServiceWorker();

if (isProduction) {
  ReactGA.initialize(process.env.REACT_APP_GA_TRACKING as string);
  ReactGA.pageview(window.location.pathname + window.location.search);
}



// WEBPACK FOOTER //
// ./src/index.tsx